<template>
  <a-modal :title="formTitle" :visible="open" width="50%" @cancel="cancel" @ok="submitForm">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 14 }">
      <a-form-model-item label="手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入手机号" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { changeMobile } from "@/api/userAdmin/userAdmin";

export default {
  name: "ChangeMobileModalForm",
  data() {
    return {
      formTitle: '修改手机号',
      open: false,
      form: {
        mobile: '',
        id: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModal(record) {
      this.form.id = record.id;
      this.form.mobile = record.mobile || '';
      this.open = true
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    reset() {
      this.form.mobile = '';
      this.form.id = '';
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          changeMobile({
            id: this.form.id,
            mobile: this.form.mobile
          }).then(res => {
            if(res.code == 20001) {
              this.open = false
              this.$message.success('修改手机号成功')
              this.$emit('ok')
            } else {
              this.$message.info(res.msg)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>

